import { z } from 'zod/v4';
import {
  accessSourceType,
  accessStatus,
  accessTargetType,
  broadcastStatus,
  documentStatus,
  fileAccess,
  fileStatus,
  homeworkStatus,
  moduleItemType,
  courseType,
  videoProcessingStatus,
  membershipStatus,
  telegramChatType,
  notificationChannel,
  notificationType,
  orderTargetType,
  reviewTargetType,
  paymentProvider,
  paymentStatus,
  repeatType,
  subscriptionStatus,
  familyMemberStatus,
  translatableEntityType,
  triggerEvent,
  limitAction,
  invitationStatus,
  contentStatus,
  privacyLevel,
  moderatableType,
  chatRoomType,
  chatParticipantRole,
  messageDeliveryStatus,
  chatParticipantStatus,
  gameType,
  lobbyStatus,
  lobbyPlayerStatus,
  gameSessionStatus,
  playerReportCategory,
  playerReportStatus,
  achievementCategory,
  achievementConditionType,
  // Импорт из /schema (только таблицы/enums, без db/pool) — иначе подключение
  // к БД (process.env) утекает в браузерные бандлы потребителей validation.
} from '@masters-club/db/schema';

// ============================================
// Access & Entitlements
// ============================================
export const accessSourceTypeEnum = z.enum(accessSourceType.enumValues);
export type AccessSourceType = z.infer<typeof accessSourceTypeEnum>;

export const accessStatusEnum = z.enum(accessStatus.enumValues);
export type AccessStatus = z.infer<typeof accessStatusEnum>;

export const accessTargetTypeEnum = z.enum(accessTargetType.enumValues);
export type AccessTargetType = z.infer<typeof accessTargetTypeEnum>;

// ============================================
// Broadcasts
// ============================================
export const broadcastStatusEnum = z.enum(broadcastStatus.enumValues);
export type BroadcastStatus = z.infer<typeof broadcastStatusEnum>;

// ============================================
// Knowledge Base
// ============================================
export const documentStatusEnum = z.enum(documentStatus.enumValues);
export type DocumentStatus = z.infer<typeof documentStatusEnum>;

// ============================================
// Files
// ============================================
export const fileAccessEnum = z.enum(fileAccess.enumValues);
export type FileAccess = z.infer<typeof fileAccessEnum>;

export const fileStatusEnum = z.enum(fileStatus.enumValues);
export type FileStatus = z.infer<typeof fileStatusEnum>;

// ============================================
// Courses & Homework
// ============================================
export const homeworkStatusEnum = z.enum(homeworkStatus.enumValues);
export type HomeworkStatus = z.infer<typeof homeworkStatusEnum>;

export const moduleItemTypeEnum = z.enum(moduleItemType.enumValues);
export type ModuleItemType = z.infer<typeof moduleItemTypeEnum>;

export const courseTypeEnum = z.enum(courseType.enumValues);
export type CourseType = z.infer<typeof courseTypeEnum>;

export const videoProcessingStatusEnum = z.enum(videoProcessingStatus.enumValues);
export type VideoProcessingStatus = z.infer<typeof videoProcessingStatusEnum>;

// ============================================
// Channel Memberships
// ============================================
export const membershipStatusEnum = z.enum(membershipStatus.enumValues);
export type MembershipStatus = z.infer<typeof membershipStatusEnum>;

// ============================================
// Telegram Chat Types
// ============================================
export const telegramChatTypeEnum = z.enum(telegramChatType.enumValues);
export type TelegramChatType = z.infer<typeof telegramChatTypeEnum>;

// ============================================
// Notifications
// ============================================
export const notificationChannelEnum = z.enum(notificationChannel.enumValues);
export type NotificationChannel = z.infer<typeof notificationChannelEnum>;

export const notificationTypeEnum = z.enum(notificationType.enumValues);
export type NotificationType = z.infer<typeof notificationTypeEnum>;

// ============================================
// Commerce & Orders
// ============================================
export const orderTargetTypeEnum = z.enum(orderTargetType.enumValues);
export type OrderTargetType = z.infer<typeof orderTargetTypeEnum>;

// ============================================
// Reviews
// ============================================
export const reviewTargetTypeEnum = z.enum(reviewTargetType.enumValues);
export type ReviewTargetType = z.infer<typeof reviewTargetTypeEnum>;

// ============================================
// Payments
// ============================================
export const paymentProviderEnum = z.enum(paymentProvider.enumValues);
export type PaymentProvider = z.infer<typeof paymentProviderEnum>;

export const paymentStatusEnum = z.enum(paymentStatus.enumValues);
export type PaymentStatus = z.infer<typeof paymentStatusEnum>;

// ============================================
// Daily Planner
// ============================================
export const repeatTypeEnum = z.enum(repeatType.enumValues);
export type RepeatType = z.infer<typeof repeatTypeEnum>;

// ============================================
// Subscriptions
// ============================================
export const subscriptionStatusEnum = z.enum(subscriptionStatus.enumValues);
export type SubscriptionStatus = z.infer<typeof subscriptionStatusEnum>;

export const familyMemberStatusEnum = z.enum(familyMemberStatus.enumValues);
export type FamilyMemberStatus = z.infer<typeof familyMemberStatusEnum>;

// ============================================
// Translations
// ============================================
export const translatableEntityTypeEnum = z.enum(translatableEntityType.enumValues);
export type TranslatableEntityType = z.infer<typeof translatableEntityTypeEnum>;

// ============================================
// Triggers
// ============================================
export const triggerEventEnum = z.enum(triggerEvent.enumValues);
export type TriggerEvent = z.infer<typeof triggerEventEnum>;

// ============================================
// Channel Pass Limit Actions
// ============================================
export const limitActionEnum = z.enum(limitAction.enumValues);
export type LimitAction = z.infer<typeof limitActionEnum>;

// ============================================
// User Invitations
// ============================================
export const invitationStatusEnum = z.enum(invitationStatus.enumValues);
export type InvitationStatus = z.infer<typeof invitationStatusEnum>;

// ============================================
// Social Features
// ============================================
export const contentStatusEnum = z.enum(contentStatus.enumValues);
export type ContentStatus = z.infer<typeof contentStatusEnum>;

export const privacyLevelEnum = z.enum(privacyLevel.enumValues);
export type PrivacyLevel = z.infer<typeof privacyLevelEnum>;

export const moderatableTypeEnum = z.enum(moderatableType.enumValues);
export type ModeratableType = z.infer<typeof moderatableTypeEnum>;

// ============================================
// Chat / Messaging
// ============================================
export const chatRoomTypeEnum = z.enum(chatRoomType.enumValues);
export type ChatRoomType = z.infer<typeof chatRoomTypeEnum>;

export const chatParticipantRoleEnum = z.enum(chatParticipantRole.enumValues);
export type ChatParticipantRole = z.infer<typeof chatParticipantRoleEnum>;

export const messageDeliveryStatusEnum = z.enum(messageDeliveryStatus.enumValues);
export type MessageDeliveryStatus = z.infer<typeof messageDeliveryStatusEnum>;

export const chatParticipantStatusEnum = z.enum(chatParticipantStatus.enumValues);
export type ChatParticipantStatus = z.infer<typeof chatParticipantStatusEnum>;

// ============================================
// Games
// ============================================
export const gameTypeEnum = z.enum(gameType.enumValues);
export type GameType = z.infer<typeof gameTypeEnum>;

export const lobbyStatusEnum = z.enum(lobbyStatus.enumValues);
export type LobbyStatus = z.infer<typeof lobbyStatusEnum>;

export const lobbyPlayerStatusEnum = z.enum(lobbyPlayerStatus.enumValues);
export type LobbyPlayerStatus = z.infer<typeof lobbyPlayerStatusEnum>;

export const gameSessionStatusEnum = z.enum(gameSessionStatus.enumValues);
export type GameSessionStatus = z.infer<typeof gameSessionStatusEnum>;

// RatingPeriod is not in Drizzle schema yet — kept locally
export const ratingPeriodValues = ['DAILY', 'WEEKLY', 'MONTHLY', 'ALL_TIME'] as const;
export const ratingPeriodEnum = z.enum(ratingPeriodValues);
export type RatingPeriod = z.infer<typeof ratingPeriodEnum>;

export const playerReportCategoryEnum = z.enum(playerReportCategory.enumValues);
export type PlayerReportCategory = z.infer<typeof playerReportCategoryEnum>;

export const playerReportStatusEnum = z.enum(playerReportStatus.enumValues);
export type PlayerReportStatus = z.infer<typeof playerReportStatusEnum>;

export const achievementCategoryEnum = z.enum(achievementCategory.enumValues);
export type AchievementCategory = z.infer<typeof achievementCategoryEnum>;

export const achievementConditionTypeEnum = z.enum(achievementConditionType.enumValues);
export type AchievementConditionType = z.infer<typeof achievementConditionTypeEnum>;
